/* eslint-disable no-restricted-globals */
import React from 'react'
import { Typography, Input, Button } from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'

const { Text } = Typography
const NumberCard = ({
  title,
  unit = '',
  number,
  setNumber,
  addonAfter,
  maxValue = 100,
  minValue = 0,
  style,
}) => {
  const onChange = type => {
    if (type === 'i' && number + 1 < maxValue) setNumber(number + 1)
    else if (type === 'd' && number - 1 > -1) setNumber(number - 1)
  }

  const setNumberValue = num => {
    if (isNaN(num)) {
      setNumber('')
    } else if (num <= maxValue && num >= minValue) {
      setNumber(num)
    }
  }

  return (
    <div
      style={{
        margin: 0,
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '14px',
        ...style,
      }}
    >
      <div>
        <Text style={{ fontSize: '16px' }}>{title}</Text>
      </div>

      <div>
        <Button style={{ marginLeft: 'auto', marginRight: 10 }} onClick={() => onChange('d')}>
          <MinusOutlined />
        </Button>
        <Input
          type="number"
          value={number}
          max={maxValue}
          style={{ width: 80, marginRight: 10 }}
          onChange={e => setNumberValue(parseInt(e.target.value, 10))}
          addonAfter={addonAfter}
        />
        <Button onClick={() => onChange('i')}>
          <PlusOutlined />
        </Button>
      </div>
    </div>
  )
}

export default NumberCard
